import React from 'react';
import googleAnalyticsShape from './googleAnalyticsShape';

export default Component => class WithGoogleAnalytics extends React.PureComponent {
    static contextTypes = {
        googleAnalytics: googleAnalyticsShape,
    }

    render() {
        return <Component {...this.props} googleAnalytics={this.context.googleAnalytics} />;
    }
};



// WEBPACK FOOTER //
// ./src/frontend/components/googleAnalytics/withGoogleAnalytics.jsx